export const googletag = window.googletag || { cmd: [] }
